<template>
  <specialist-form
    v-model="form"
    :photo-url="null"
    class="w-full bg-white"
    @submit="submit"
  >
    <div
      class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-6 py-4"
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Utwórz specjalistę
      </loading-button>
    </div>
  </specialist-form>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useForm } from '@inertiajs/vue3';
import LoadingButton from '@/Shared/LoadingButton.vue';
import SpecialistForm from './Form.vue';
import { createSpecialistRouteHelper } from '@/utils/createSpecialistRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

const emptyLocale = () => ({
  description: '',
  important_information: [],
  treated_diseases: [],
  faq: [],
});

const form = useForm({
  specialist: {
    first_name: '',
    last_name: '',
    title: '',
    active: true,
    use_local_description: false,
    requires_prepayment: false,
    media: [],
    specialisation_ids: [],
    language_ids: [],
    data_pl: emptyLocale(),
    data_en: emptyLocale(),
    photo: null,
  },
});

const specialistRoutes = computed(() => {
  return createSpecialistRouteHelper(null, routes);
});

const emit = defineEmits(['success']);

const submit = () => {
  form.post(specialistRoutes.value.index(), {
    onFinish: () => {
      if (!form.hasErrors) {
        form.reset();
        form.specialist.active = true;
        form.specialist.media = [];
        form.specialist.specialisation_ids = [];
        form.specialist.language_ids = [];
        form.specialist.data_pl = emptyLocale();
        form.specialist.data_en = emptyLocale();
      }
    },
    onSuccess: () => {
      emit('success');
    },
    onError: () => {},
  });
};
</script>
